import React, { useMemo } from 'react';

import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@material-ui/core';
import PropTypes from 'prop-types';

import { number, t } from '~/helpers';

function fieldValue(value) {
  return value || '';
}

function getDescricaoItem(item) {
  if (!item) return '';
  if (item.descricao) return item.descricao;
  if (item.estoqueAreiaVO) {
    return (
      item.estoqueAreiaVO.nomepostotipoareia ||
      item.estoqueAreiaVO.descricaotipoareia ||
      ''
    );
  }
  return item.nomepostotipoareia || item.descricaotipoareia || '';
}

function ReadOnlyField({ label, value, multiline }) {
  return (
    <TextField
      label={label}
      value={fieldValue(value)}
      variant="outlined"
      fullWidth
      size="small"
      multiline={multiline}
      rows={multiline ? 2 : 1}
      InputLabelProps={{ shrink: true }}
      InputProps={{ readOnly: true }}
    />
  );
}

export default function View({ data }) {
  const itens = data?.itens || [];

  const totalPesoItens = useMemo(
    () =>
      itens.reduce(
        (total, item) =>
          total + Number(item.pesototalkgrecebimentoareianfitem || 0),
        0
      ),
    [itens]
  );

  return (
    <Grid
      container
      spacing={2}
      style={{
        width: '100%',
        margin: 0,
        padding: 8,
      }}
    >
      <Grid item xs={12} md={6}>
        <ReadOnlyField
          label={t('s.configuracao.terminal.nomeposto')}
          value={data?.codigonomeposto || data?.idposto}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <ReadOnlyField
          label={t('s.geral.fornecedor')}
          value={
            data?.nomedistribuidoranfe ||
            data?.cnpjdistribuidoranferecebimentoareianf
          }
        />
      </Grid>

      <Grid item xs={12} sm={6} md={3}>
        <ReadOnlyField
          label={t('s.configuracao.tanquefisico.numerosondatanquefisico')}
          value={data?.numeronfrecebimentoareianf}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={3}>
        <ReadOnlyField
          label={t('s.operacao.recebimento.placactdescarga')}
          value={data?.placactrecebimentoareianf}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={3}>
        <ReadOnlyField
          label={t('s.relatorio.descarga.pedido')}
          value={data?.numeropedidorecebimentoareianf}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={3}>
        <ReadOnlyField
          label={t('s.geral.pesodeclarado') + ` Kg`}
          value={data?.quantidaderecebimentoareianf}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <ReadOnlyField
          label={t('s.operacao.notafiscalrecebida.emissaonfe')}
          value={data?.dataemissaonfrecebimentoareianf}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <ReadOnlyField
          label={t('s.geral.datachegada')}
          value={data?.datachegadarecebimentoareianf}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <ReadOnlyField
          label="Executor"
          value={
            data?.nomeusuariorecebimentoareianf ||
            data?.idusuariorecebimentoareianf
          }
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <ReadOnlyField
          label={t('s.geral.observacao')}
          value={data?.observacaorecebimentoareianf}
          multiline
        />
      </Grid>

      <Grid item xs={12}>
        <Typography variant="subtitle1">
          {t('s.geral.itensrecebidos')}
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Paper variant="outlined">
          <div style={{ width: '100%', overflowX: 'auto' }}>
            <Table size="small" style={{ minWidth: 640 }}>
              <TableHead>
                <TableRow>
                  <TableCell>{t('s.cadastro.pitstop.tipoareia')}</TableCell>
                  <TableCell align="right">{t('s.geral.sacos')}</TableCell>
                  <TableCell align="right">
                    {t('s.geral.pesounitario')} Kg
                  </TableCell>
                  <TableCell align="right">
                    {t('s.geral.pesototal')} Kg
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {itens.map((item) => (
                  <TableRow
                    key={
                      item.idrecebimentoareianfitem || item.idpostotipoareia
                    }
                  >
                    <TableCell>{getDescricaoItem(item)}</TableCell>
                    <TableCell align="right">
                      {number(
                        item.quantidadesacosrecebimentoareianfitem || 0,
                        '2'
                      )}
                    </TableCell>
                    <TableCell align="right">
                      {number(
                        item.pesounitariokgrecebimentoareianfitem || 0,
                        '2'
                      )}
                    </TableCell>
                    <TableCell align="right">
                      {number(
                        item.pesototalkgrecebimentoareianfitem || 0,
                        '2'
                      )}
                    </TableCell>
                  </TableRow>
                ))}
                <TableRow>
                  <TableCell>
                    <strong>{t('s.geral.total')}</strong>
                  </TableCell>
                  <TableCell align="right" />
                  <TableCell align="right" />
                  <TableCell align="right">
                    <strong>{number(totalPesoItens, '2')}</strong>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </div>
        </Paper>
      </Grid>
    </Grid>
  );
}

ReadOnlyField.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  multiline: PropTypes.bool,
};

ReadOnlyField.defaultProps = {
  value: '',
  multiline: false,
};

View.propTypes = {
  data: PropTypes.objectOf(PropTypes.any),
};

View.defaultProps = {
  data: {},
};
